import { render, staticRenderFns } from "./JumpingGame.vue?vue&type=template&id=0a2f3d2b&scoped=true&"
import script from "./JumpingGame.vue?vue&type=script&lang=js&"
export * from "./JumpingGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2f3d2b",
  null
  
)

export default component.exports